<template>
	<div class="addEdit-block">
		<el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="110px">
			<el-row>
				<el-col :span="12">
					<el-form-item label="标题" prop="title">
						<el-input v-model="ruleForm.title" placeholder="标题" clearable :readonly="ro.title"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="分类" prop="category">
						<el-select v-model="ruleForm.category" placeholder="请选择分类" :disabled="ro.category">
							<el-option label="全职招聘" value="fulltime"></el-option>
							<el-option label="兼职招聘" value="parttime"></el-option>
							<el-option label="实习招聘" value="intern"></el-option>
							<el-option label="个人求职" value="jobsearch"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="24">
					<el-form-item label="详细描述" prop="content">
						<el-input v-model="ruleForm.content" type="textarea" :rows="6" placeholder="请详细描述招聘要求、薪资待遇、工作时间等信息..." :readonly="ro.content"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="12">
					<el-form-item label="标签" prop="tags">
						<el-input v-model="ruleForm.tags" placeholder="多个标签用逗号分隔，如：客服,全职,无障碍" clearable :readonly="ro.tags"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="联系方式" prop="contact">
						<el-input v-model="ruleForm.contact" placeholder="如：电话、微信等" clearable :readonly="ro.contact"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="24">
					<el-form-item label="图片" prop="images">
						<file-upload
							tip="点击上传图片"
							:disabled="ro.images"
							action="file/upload"
							:limit="3"
							:fileUrls="ruleForm.images?ruleForm.images:''"
							@change="imagesUploadChange"
						></file-upload>
					</el-form-item>
				</el-col>
			</el-row>
			
		<el-row>
			<el-col :span="12">
				<el-form-item label="发布人" prop="username">
					<el-input v-model="ruleForm.username" placeholder="发布人" clearable :readonly="true"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="是否置顶" prop="isTop">
					<el-switch v-model="ruleForm.isTop" :active-value="1" :inactive-value="0" :disabled="ro.isTop"></el-switch>
				</el-form-item>
			</el-col>
		</el-row>
		</el-form>
		<div class="formModel-btns" v-if="type!='info'">
			<el-button class="btn-success" @click="onSubmit" type="success">提交</el-button>
			<el-button class="btn-close" @click="back()">取消</el-button>
		</div>
		<div class="formModel-btns" v-else>
			<el-button class="btn-close" @click="back()">返回</el-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: '',
			type: '',
		ruleForm: {
			title: '',
			content: '',
			category: '',
			username: '',
			tags: '',
			images: '',
			contact: '',
			isTop: 0
		},
			ro: {
				title: false,
				content: false,
				category: false,
				username: false,
				tags: false,
				images: false,
				contact: false,
				isTop: false
			},
			rules: {
				title: [{
					required: true,
					message: '标题不能为空',
					trigger: 'blur'
				}],
				content: [{
					required: true,
					message: '详细描述不能为空',
					trigger: 'blur'
				}],
				category: [{
					required: true,
					message: '请选择分类',
					trigger: 'change'
				}]
			}
		}
	},
	props: ['parent'],
	computed: {},
	methods: {
		init(id, type) {
			this.id = id || 0
			this.type = type || ''
			this.ruleForm = {
				title: '',
				content: '',
				category: '',
				username: '',
				tags: '',
				images: '',
				contact: '',
				isTop: 0
			}
			if (this.type == 'info') {
				this.ro.title = true
				this.ro.content = true
				this.ro.category = true
				this.ro.username = true
				this.ro.tags = true
				this.ro.images = true
				this.ro.contact = true
				this.ro.isTop = true
			} else {
				this.ro.title = false
				this.ro.content = false
				this.ro.category = false
				this.ro.username = false
				this.ro.tags = false
				this.ro.images = false
				this.ro.contact = false
				this.ro.isTop = false
			}
			this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
				if (this.id) {
					this.getInfo()
				} else {
					// 新增模式：自动获取当前登录用户信息
					this.getUserInfo()
				}
			})
		},
		// 获取当前登录用户信息
		getUserInfo() {
			this.$http({
				url: `${this.$storage.get('sessionTable')}/session`,
				method: 'get'
			}).then(({data}) => {
				if (data && data.code === 0) {
					// 自动填充当前登录用户的用户名
					this.ruleForm.username = data.data.username || data.data.yonghuming || ''
				}
			})
		},
		// 获取信息
		getInfo() {
			this.$http({
				url: `recruitmentPost/info/${this.id}`,
				method: 'get'
			}).then(({data}) => {
				if (data && data.code === 0) {
					// 使用 Object.assign 避免直接赋值响应式对象
					this.ruleForm = Object.assign({}, this.ruleForm, {
						title: data.data.title,
						content: data.data.content,
						category: data.data.category,
						username: data.data.username,
						tags: data.data.tags,
						images: data.data.images,
						contact: data.data.contact,
						isTop: data.data.isTop || 0
					})
				}
			})
		},
		// 图片上传回调
		imagesUploadChange(fileUrls) {
			this.ruleForm.images = fileUrls
		},
		// 提交
		onSubmit() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					this.$http({
						url: `recruitmentPost/${!this.id ? 'save' : 'update'}`,
						method: 'post',
						data: this.ruleForm
					}).then(({data}) => {
						if (data && data.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.parent.showFlag = true
									this.parent.search()
								}
							})
						} else {
							this.$message.error(data.msg)
						}
					})
				}
			})
		},
		back() {
			this.parent.showFlag = true
		}
	}
}
</script>

<style lang="scss" scoped>
.addEdit-block {
	padding: 20px;
	
	.detail-form-content {
		background: #fff;
		padding: 20px;
		border-radius: 4px;
	}
	
	.formModel-btns {
		text-align: center;
		margin-top: 20px;
		
		.btn-success {
			width: 120px;
		}
		
		.btn-close {
			width: 120px;
			margin-left: 20px;
		}
	}
}
</style>

